import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";

class ReportForm {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.currentSection = -1;

        this.bindEvents();

        this.showSection(0, false);

        this.$wrapper.find(".js-other-row, .js-yes-row").hide().find("input").attr("disabled", true);
        this.$wrapper.find("input:checked").change();
    }

    bindEvents() {
        const me = this;

        this.$wrapper.find(".js-report-section-form").get().forEach((el, index) => {
            let $form = $(el);

            let options = {
                inputOptions: {
                    getOperator: function () {
                        if (index === 2) {
                            return 'the';
                        }
                        let name = this.$input.attr("name");

                        if (name.indexOf("agency-worker") >= 0) {
                            return "your";
                        } else if (name.indexOf("agency") >= 0) {
                            return "the";
                        } else {
                            return me.$wrapper.is(".report-now--public") ? "your" : "their";
                        }
                    },
                },
                inputs: {
                    'help-required-other': {messages: {empty: "This value is required"}},
                    'location-other': {messages: {empty: "This value is required"}},
                    'type-of-incident-other': {messages: {empty: "This value is required"}},
                    'motivation-other': {messages: {empty: "This value is required"}},
                    'already-reported-yes': {messages: {empty: "Please specify who you have already reported this to"}},
                    'reporting-on-behalf-of': {messages: {empty: "Please specify who you are reporting this on behalf of"}},
                },
            };

            FormValidator.attach($form, options).on("invalid", function (data) {
                let $target = $(".form__row--invalid:visible:first");
                if ($target.length > 0) {
                    $("html,body").animate({scrollTop: $target.offset().top - $(".header").outerHeight() - $(".header").position().top});
                } else {
                    console.log(data);
                }
            }).on("input:invalid", ({input}) => {
                input.$input.parents(".form__row").first().addClass("form__row--invalid");
                if (input.$input.is(":checkbox,:radio")) {
                    input.$input.parents("fieldset").find("legend").addClass("form__legend--invalid");
                }
            }).on("input:valid", ({input}) => {
                input.$input.parents(".form__row").first().removeClass("form__row--invalid");

                if (input.$input.is(":checkbox,:radio")) {
                    input.$input.parents("fieldset").find("legend").removeClass("form__legend--invalid");
                }
            }).on("submit", ($form) => {
                this.showSection($form.index() + 1);
            });
        });

        this.$wrapper.on("click", ".js-back", function () {
            me.showSection(me.currentSection - 1);
            return false;
        }).on("change", ".js-reporter-type", function () {
            let type = $('.js-reporter-type:checked').attr("value");
            me.$wrapper.removeClass("report-now--public report-now--agency").addClass("report-now--" + type);
            me.$wrapper.find(".form__row--public, .form__row--agency").find("input").attr("disabled", true);
            me.$wrapper.find(".form__row--" + type + " input").removeAttr("disabled");
        }).on("change", ".js-anonymous", function () {
            let checked = $(this).is(":checked");
            let $nonAnonymous = me.$wrapper.find(".js-non-anonymous");

            let $inputs = $nonAnonymous.not('.js-has-other,.js-has-yes').find("input,textarea")
                                       .add($nonAnonymous.filter(".js-has-other").find(".form__row:not(.js-other-row) input")).attr("disabled", checked)
                                       .add($nonAnonymous.filter(".js-has-yes").find(".form__row:not(.js-yes-row)").find("input, textarea")).attr("disabled", checked);

            let $otherInputs = $nonAnonymous.filter(".js-has-other").find(".js-other-row input");
            let $yesInputs = $nonAnonymous.filter(".js-has-yes").find(".js-yes-row input");

            if (checked) {
                $otherInputs.add($yesInputs).attr("disabled", true);
                $inputs.add($otherInputs).each(function () {
                    let validator = $(this).data("Validator");
                    if (validator) {
                        validator.validate();
                    }
                });
                $nonAnonymous.hide();
            } else {
                $nonAnonymous.show();
                me.$wrapper.find("input:checked").not(".js-anonymous").change();
            }
        }).on("change", ".js-has-other :checkbox, .js-has-other :radio", function () {
            if (me.$wrapper.find("[name='" + $(this).attr("name") + "'][value='Other']").is(":checked")) {
                $(this).parents(".js-has-other").find(".js-other-row").show().find("input").removeAttr("disabled");
            } else {
                $(this).parents(".js-has-other").find(".js-other-row").hide().find("input").attr("disabled", true);
            }
        }).on("change", ".js-has-yes :checkbox, .js-has-yes :radio", function () {
            if (me.$wrapper.find("[name='" + $(this).attr("name") + "'][value='Yes']").is(":checked")) {
                $(this).parents(".js-has-yes").find(".js-yes-row").show().find("input,textarea").removeAttr("disabled");
            } else {
                $(this).parents(".js-has-yes").find(".js-yes-row").hide().find("input,textarea").attr("disabled", true);
            }
        }).on("change", ".js-incident-in-warwickshire", () => {
            let value = $(".js-incident-in-warwickshire:checked").val();

            if (value === "No") {
                $(".js-non-warwickshire-message").show();
                $(".js-reporter-type").parents("fieldset").hide();
                $(".js-report-to-wrap").hide();
                $(".js-step-one-continue").attr("disabled", true);
            } else {
                $(".js-non-warwickshire-message").hide();
                $(".js-reporter-type").parents("fieldset").show();
                if ($(".js-report-to-wrap").show().find("input:checked").change().length === 0) {
                    $(".js-step-one-continue").attr("disabled", false);
                }
            }
        }).on("change", ".js-report-to", () => {
            let value = $(".js-report-to:checked").val();

            if (value === "Police") {
                $(".js-report-to-police-message").show();
                $(".js-reporter-type").parents("fieldset").hide();
                $(".js-step-one-continue").attr("disabled", true);
            } else {
                $(".js-report-to-police-message").hide();
                $(".js-reporter-type").parents("fieldset").show();
                $(".js-step-one-continue").attr("disabled", false);
            }
        }).on("change", "input[name='method-of-contact']", () => {
            let value = $("input[name='method-of-contact']:checked").val();

            let $questions = $(".js-contact-me-question");
            if (value === "Please don't contact me") {
                $questions.hide().find("input").attr("disabled", true);
            } else {
                $questions.show().find("input").attr("disabled", false);
            }
        });
    }

    showSection(section, scroll = true) {
        if (section === this.currentSection) return;

        if (section < 0) {
            return;
        } else if (section > 2) {
            this.submitForm();
            return;
        }
        this.$wrapper.find(".js-report-section-form").addClass("form--hide").eq(section).removeClass("form--hide");

        let $progressItems = this.$wrapper.find(".js-progress").find(".js-progress-item");
        $progressItems.removeClass("form-progress__item--complete form-progress__item--in-progress");
        $progressItems.eq(section).addClass("form-progress__item--in-progress");
        $progressItems.slice(0, section).addClass("form-progress__item--complete");

        if (section > 0) {
            this.$wrapper.find(".js-sticky-back").show();
        } else {
            this.$wrapper.find(".js-sticky-back").hide();
        }


        this.currentSection = section;

        if (scroll) {
            $(window).scrollTop(this.$wrapper.offset().top - $(".header").outerHeight() - $(".header").position().top);
        }
    }

    getFormData() {
        return this.$wrapper.find(".js-report-section-form").serializeJSON();
    }

    submitForm() {
        let data = this.getFormData();
        let $btn = this.$wrapper.find("button[type=submit]");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass("btn--loading");

        Ajax.post("hateCrime", "report", data, Ajax.WEBSITE).then(() => {
            window.location.href = '/report-now-complete';
        }).catch((e) => {
            $btn.removeClass("btn--loading");
            if (e.data && e.data.exception === 'HttpValidationException') {
                let first = null;
                this.$wrapper.find(".js-report-section-form").get().forEach((el, i) => {
                    if ($(el).data("Validator").handleValidationException(e).length < e.data.data.length && first === null) {
                        first = i;
                    }
                });
                if (first !== null) {
                    this.showSection(first, false);
                    let $target = $(".form__row--invalid:first");
                    $("html,body").animate({scrollTop: $target.offset().top - $(".header").outerHeight() - $(".header").position().top});
                }
            } else {
                alert(e.message);
            }
            console.log(e);
        });
    }
}

export default ReportForm;
